import { render, staticRenderFns } from "./interpretation.vue?vue&type=template&id=2885deae&scoped=true"
import script from "./interpretation.vue?vue&type=script&lang=js"
export * from "./interpretation.vue?vue&type=script&lang=js"
import style0 from "./interpretation.vue?vue&type=style&index=0&id=2885deae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2885deae",
  null
  
)

export default component.exports